module.exports = __webpack_public_path__ + "assets/img/CMTP-Website-w540.529f97e7.jpg";